import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from "react-error-boundary";
import './index.css';
import ClientAppDataLoader from './ClientAppDataLoader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<p>⚠️Something went wrong. Please try again later</p>}>
      <ClientAppDataLoader />
    </ErrorBoundary>
  </React.StrictMode>
);
